export const GET_STUDENTS = 'students/GET_STUDENTS';
export const CREATE_STUDENT = 'students/CREATE_STUDENT';
export const GET_SCHOOL_STUDENTS = 'students/GET_SCHOOL_STUDENTS';
export const FINISH_IMPORT_STUDENTS = 'students/FINISH_IMPORT_STUDENTS';
export const REMOVE_STUDENT_BY_ID = 'students/REMOVE_STUDENT_BY_ID';
